const performanceDashboard = {
  supplierSelector: {
    label: 'Elegir Flota:',
  },
};

export default performanceDashboard;
